import React, { useState } from "react";
import "./faq.css";
import { fadeVariants } from "../../Animations/fadeVariants.js";
import { AnimatePresence, motion } from "framer-motion";
import Form from "../../Components/Form/Form.jsx";

const faqData = [
  {
    question: "What services do you offer?",
    answer:
      "We offer dog walking and boarding in Jersey City.",
  },
  {
    question: "How do I book a walk or service?",
    answer:
      "You can contact us via WhatsApp or iMessage anytime to schedule a service.",
  },
  {
    question: "Do you do private walks?",
    answer:
      "Although we do group walks for efficiency and for your dog to socialize, we can offer private walks if there is any avialability on our schedule.",
  },
  {
    question: "What is the cancellation policy?",
    answer:
      "We understand that plans can change. You can cancel anytime before the scheduled walk — just give us at least an hour's notice if possible.",
  },
  {
    question: "Is there any extra charge for holidays?",
    answer: "No, we don’t charge extra for holidays or weekends.",
  },
  {
    question: "Do you send pictures from the walks?",
    answer: "Yes! We love sharing photos of your dog after their walk.",
  },
  {
    question: "What kind of payment methods do you accept?",
    answer:
      "We accept payments through Zell or Venmo - whichever you prefer.",
  },
  {
    question: "Can you feed my dog?",
    answer: "Absolutely—we’re happy to help with feeding and other basic care.",
  },
  {
    question: "Do you accept last minute requests?",
    answer:
      "Yes! If we’re nearby and have availability, we’re happy to accommodate last-minute requests at no extra cost.",
  },
  {
    question: "How long are the walks?",
    answer:
      "Walks typically last between 30 minutes to 1 hour, depending on your dog’s needs and the weather.",
  },
  {
    question: "Can you take care of puppies or senior dogs?",
    answer:
      "Absolutely! We’re experienced with dogs of all ages and happy to adjust our care to fit their specific needs.",
  },
  {
    question: "Do you do meet-and-greets before the first walk?",
    answer:
      "Yes, we’re happy to schedule a short meet-and-greet so your dog can get to know us first.",
  },
  {
    question: "Do you do daycare?",
    answer:
      "Due to our current schedule, we are unable to offer full daycare services. We provide daily lunch walks and overnight boarding. If you have a weekend evening or morning commitment and would like a walk outside of our regular schedule, please feel free to inquire about our availability.",
  },
  {
    question: "Can we do a trial night before boarding?",
    answer:
      "Yes, we are happy to see if your pup is comfortable staying with us before scheduling a boarding.",
  },
];

function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <motion.div
      variants={fadeVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="header-1">
        <a href="/" className="home-button">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="24px"
            fill="#1f1f1f"
          >
            <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
          </svg>
        </a>
        <h1 className="header">FAQ</h1>
      </div>{" "}
      <div className="faq-list">
        {faqData.map((item, index) => (
          <div key={index} className="faq-item">
            <button className="faq-question" onClick={() => toggleFAQ(index)}>
              {item.question}
            </button>

            <AnimatePresence initial={false}>
              {openIndex === index && (
                <motion.div
                  className="faq-answer-wrapper"
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.3, ease: "easeInOut" }}
                >
                  <p className="faq-answer">{item.answer}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
      </div>
      <div className="info-form">
        <p className="info-text-2">
          Couldn't find your answer? <br /> Please reach us if you have more questions.
        </p>
        <Form />
        <img src="https://i.imgur.com/5khcDmn.jpeg" alt="Dogs on a sofa drawing" className="pic-on-bike"/>
      </div>
    </motion.div>
  );
}

export default Faq;
